import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, keywords, canonical, og }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description"    content={description}/>
      <meta name="keywords"       content={keywords}/>
      <meta name="robots"         content="index, follow"/>
      <link rel="canonical"       href={canonical}/>
      <meta property="og:title"       content={og?.title       || title}/>
      <meta property="og:description" content={og?.description || description}/>
      <meta property="og:url"         content={og?.url         || canonical}/>
      <meta property="og:type"        content="website"/>
      {og?.image && <meta property="og:image" content={og.image}/>}
      <meta name="twitter:card"        content="summary_large_image"/>
      <meta name="twitter:title"       content={og?.title       || title}/>
      <meta name="twitter:description" content={og?.description || description}/>
      {og?.image && <meta name="twitter:image" content={og.image}/>}
    </Helmet>
  );
}